/**
 * Created by Petr Kubišta on 02.01.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {

        /**
         * Directs calls to native mobile code
         * @memberOf Lfl.Mobile
         */
        Lfl.Mobile.Sender = Mobile.Sender || {};

        (function (Sender, $, undefined) {

            if (MobileCallbacks.mobilePlatform() === "none") {

                Sender.onAjaxSuccess = function (result) {
                };

                Sender.onAjaxFailure = function (taskId, x, errorText, y) {
                };

                Sender.onUserReturned = function (result) {
                };

                Sender.showSettings = function () {
                };

                Sender.onMessageCountUpdated = function (count) {
                };

                Sender.tokenRegistered = function (success) {
                };

                Sender.onModalOpen = function () {
                };

                Sender.onModalClosed = function () {
                };

                Sender.onPhotoswipeOpen = function () {
                };

                Sender.onPhotoswipeClosed = function () {
                };

                Sender.onPhotoswipeFocus = function (focus) {
                };

                Sender.modalClosePassed = function () {
                };

                Sender.onLoggedIn = function () {
                };

                Sender.saveUsername = function (username) {
                };

                Sender.setInstallationUrl = function (installationUrl) {
                };

                Sender.resetInstallationUrl = function () {
                };

                Sender.setBadgeCount = function (badgeCount) {
                };

                Sender.requestCurrentInstallationUrl = function (promiseId) {
                    Lfl.Mobile.resolveCurrentInstallationUrl(promiseId, Lfl.Mobile.CURRENT_INSTALLATION_URL_UNAVAILABLE);
                };

                Sender.requestHasUsedCurrentInstallation = function (promiseId) {
                    Lfl.Mobile.resolveHasUsedCurrentInstallation(promiseId, Lfl.Mobile.HAS_USED_CURRENT_INSTALLATION_UNAVAILABLE);
                };

                Sender.wasMobileNotificationsIssuesInfoPageDisplayed = function () {
                    return true;
                };

                Sender.setMobileNotificationsIssuesInfoPageDisplayed = function () {
                };

                Sender.getMobileNotificationsIssuesInfoPageDisplayedTimestamp = function () {
                    return -1;
                };

                Sender.setMobileNotificationsIssuesInfoPageDisplayedTimestamp = function (timestamp) {
                };

                Sender.wasMobileNotificationsIssuesInfoPageResolved = function () {
                    return true;
                };

                Sender.setMobileNotificationsIssuesInfoPageResolved = function () {
                };
            }

        }(Mobile.Sender = Mobile.Sender || {}, jQuery));
    }(Lfl.Mobile = Lfl.Mobile || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
